import { __exports as i } from "../../../../_virtual/classList.js";
Object.defineProperty(i, "__esModule", {
  value: !0
});
i.resetState = d;
i.log = m;
var o = {}, a = {};
function s(t, e) {
  t.classList.remove(e);
}
function d() {
  var t = document.getElementsByTagName("html")[0];
  for (var e in o)
    s(t, o[e]);
  var n = document.body;
  for (var r in a)
    s(n, a[r]);
  o = {}, a = {};
}
function m() {
  if (process.env.NODE_ENV !== "production") {
    var t = document.getElementsByTagName("html")[0].className, e = `Show tracked classes:

`;
    e += "<html /> (" + t + `):
  `;
    for (var n in o)
      e += "  " + n + " " + o[n] + `
  `;
    t = document.body.className, e += `

doc.body (` + t + `):
  `;
    for (var r in a)
      e += "  " + r + " " + a[r] + `
  `;
    e += `
`, console.log(e);
  }
}
var u = function(e, n) {
  return e[n] || (e[n] = 0), e[n] += 1, n;
}, v = function(e, n) {
  return e[n] && (e[n] -= 1), n;
}, f = function(e, n, r) {
  r.forEach(function(c) {
    u(n, c), e.add(c);
  });
}, l = function(e, n, r) {
  r.forEach(function(c) {
    v(n, c), n[c] === 0 && e.remove(c);
  });
};
i.add = function(e, n) {
  return f(e.classList, e.nodeName.toLowerCase() == "html" ? o : a, n.split(" "));
};
i.remove = function(e, n) {
  return l(e.classList, e.nodeName.toLowerCase() == "html" ? o : a, n.split(" "));
};
export {
  i as default
};
